var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative",attrs:{"id":"app"}},[_c('router-view'),_c('feedback'),(_vm.showDataSourceListComponent)?_c('div',{staticClass:"position-fixed datasource-list"},[_c('ShowDataSourcesList')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }